<div fxFlex="1 1 auto" fxLayoutAlign="end center">
  <elm-app-user-actions (logout)="logout()" class="elm-app451-btn elm-dynamic-bg-primary">
    {{ userData$ | async | elmUserShortName }}
  </elm-app-user-actions>
</div>
